import api from '../shared/services/api';

export interface FieldRegistryEntry {
  id: number;
  field_key: string;
  atlas_path: string | null;
  section: string;
  label_en: string | null;
  label_de: string | null;
  format: string | null;
  pattern: string | null;
  codelist_id: string | null;
  ml_predictor_name: string | null;
  ml_system_name: string | null;
  required_status: string;
  visibility_driver: string | null;
  max_occurrences: number;
  description: string | null;
  is_active: boolean;
}

export interface FieldRegistryStats {
  total: number;
  active: number;
  with_codelist: number;
  with_ml_mapping: number;
}

const fieldRegistryService = {
  async getAll(section?: string, activeOnly = true): Promise<{ fields: FieldRegistryEntry[]; total: number }> {
    const params = new URLSearchParams();
    if (section) params.append('section', section);
    params.append('active_only', String(activeOnly));
    const { data } = await api.get(`/api/v1/admin/field-registry/?${params}`);
    return data;
  },

  async getStats(): Promise<FieldRegistryStats> {
    const { data } = await api.get('/api/v1/admin/field-registry/stats');
    return data;
  },

  async getSections(): Promise<string[]> {
    const { data } = await api.get('/api/v1/admin/field-registry/sections');
    return data.sections;
  },

  async updateField(fieldKey: string, updates: Partial<FieldRegistryEntry>): Promise<FieldRegistryEntry> {
    const { data } = await api.put(`/api/v1/admin/field-registry/${fieldKey}`, updates);
    return data;
  },

  async exportAll(): Promise<FieldRegistryEntry[]> {
    const { data } = await api.get('/api/v1/admin/field-registry/export');
    return data.fields;
  },
};

export default fieldRegistryService;
